const Add = ({ height = 18, width = 18, color = 'currentColor' }:{height?: number, width?: number, color?: string}) => {
    return (
        <svg width={width} color={color} height={height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 13V27" stroke="currentColor" />
            <path d="M27 20L13 20" stroke="currentColor" />
        </svg>
    )
}

export default Add